<template>
  <header class="navbar">
      <div class="container-fluid">
          <button class="navbar-toggler mobile-toggler hidden-lg-up" type="button">☰</button>
          <router-link to="/dashboard" exact class="navbar-brand" style="padding:0; text-align: center;background-image: none;" >
            <span v-if="!logo">{{ company_name }}</span>
            <img v-else class="logo" v-bind:src="logo" width="220" height="40">
          </router-link>      
          <ul class="nav navbar-nav hidden-md-down float-xs-left">
              <li class="nav-item">
                  <a class="nav-link navbar-toggler layout-toggler" href="#">☰</a>
              </li>

          </ul>

          <ul class="nav navbar-nav float-xs-right">
              <li class="nav-item dropdown">
                  <a class="nav-link avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                      <i class="icon-user icons font-2xl" style="color: #36a9e1;"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                      <router-link :to="{path: '/settings/profile', }" exact class="dropdown-item">
                          <i class="fa fa-user"></i> Profile
                      </router-link>
                      <a class="dropdown-item" href="#" @click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
                  </div>
              </li>
          </ul>
      </div>
  </header>
</template>

<script>
  export default {
    data () {
      return {
        logo: '',
        company_name: 'The Company Name'
      }
    },
    created () {
      var company = (localStorage.getItem('session_company')) ? JSON.parse(localStorage.getItem('session_company')) : []
      if (Object.keys(company).length) {
        this.company_name = company.name
        this.logo = company.logo
      }
    },
    methods: {
      logout: function (event) {
        this.$store.dispatch('logout')
        this.$router.push('/login')

        localStorage.removeItem('session_company')
        localStorage.removeItem('session_permissions')
        localStorage.removeItem('session_roles')
        localStorage.removeItem('session_user_login_count')
        localStorage.removeItem('session_user')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Header.vue